import i18n from 'shared/lib/i18n';

import {
  CHECK_DOCUMENT_FAILURE,
  CHECK_DOCUMENT_REQUESTED,
  CHECK_DOCUMENT_SUCCESS,
  CLEAR_ALL_DIRECTORY_DATA,
  CLEAR_DIRECTORY_DATA,
  CREATE_DIRECTORY_FAILURE,
  CREATE_DIRECTORY_REQUESTED,
  CREATE_DIRECTORY_SUCCESS,
  DELETE_DIRECTORY_FAILURE,
  DELETE_DIRECTORY_REQUESTED,
  DELETE_DIRECTORY_SUCCESS,
  DELETE_FILE_FAILURE,
  DELETE_FILE_REQUESTED,
  DELETE_FILE_SUCCESS,
  GET_ADMIN_ROOT_DIRECTORIES_FAILURE,
  GET_ADMIN_ROOT_DIRECTORIES_REQUESTED,
  GET_ADMIN_ROOT_DIRECTORIES_SUCCESS,
  GET_DIRECTORIES_BY_ID_FAILURE,
  GET_DIRECTORIES_BY_ID_REQUESTED,
  GET_DIRECTORIES_BY_ID_SUCCESS,
  GET_DIRECTORIES_FAILURE,
  GET_DIRECTORIES_REQUESTED,
  GET_DIRECTORIES_SUCCESS,
  GET_DIRECTORY_DATA_BY_ID_FAILURE,
  GET_DIRECTORY_DATA_BY_ID_REQUESTED,
  GET_DIRECTORY_DATA_BY_ID_SUCCESS,
  GET_DIRECTORY_DATA_FOR_EDIT_FAILURE,
  GET_DIRECTORY_DATA_FOR_EDIT_REQUESTED,
  GET_DIRECTORY_DATA_FOR_EDIT_SUCCESS,
  GET_DOCUMENT_FAILURE,
  GET_DOCUMENT_REQUEST,
  GET_DOCUMENT_SUCCESS,
  GET_NUMBER_OF_CHILDREN_FAILURE,
  GET_NUMBER_OF_CHILDREN_REQUESTED,
  GET_NUMBER_OF_CHILDREN_SUCCESS,
  SEARCH_DIRECTORY_FAILURE,
  SEARCH_DIRECTORY_REQUESTED,
  SEARCH_DIRECTORY_SUCCESS,
  SET_MODAL_TYPE,
  UPDATE_DIRECTORY_FAILURE,
  UPDATE_DIRECTORY_REQUESTED,
  UPDATE_DIRECTORY_SUCCESS,
  UPLOAD_FILE_FAILURE,
  UPLOAD_FILE_REQUESTED,
  UPLOAD_FILE_SUCCESS,
} from '../../../actionConstants';

import { getTodayCount, loadUser } from '../../../utils';
import { sendGA4Event } from '../../Shared/utils/ga';

import apiClient from '../../../apiClient';
import { CONFIRM } from '../../Modal/modalTypes';

export const getAdminRootDirectories = (dispatch) =>
  dispatch({
    type: GET_ADMIN_ROOT_DIRECTORIES_REQUESTED,
    payload: apiClient.documentLibrary.getAdminRootDirectories().then(
      (res) => {
        dispatch({
          type: GET_ADMIN_ROOT_DIRECTORIES_SUCCESS,
          payload: res,
        });
        return res.data;
      },
      (err) =>
        dispatch({
          type: GET_ADMIN_ROOT_DIRECTORIES_FAILURE,
          err,
        }),
    ),
  });
export const getRootDirectories = (dispatch, queryParams = {}) =>
  dispatch({
    type: GET_DIRECTORIES_REQUESTED,
    payload: apiClient.documentLibrary.getDirectories(queryParams).then(
      (res) => {
        dispatch({
          type: CLEAR_DIRECTORY_DATA,
        });
        dispatch({
          type: GET_DIRECTORIES_SUCCESS,
          res,
        });
        return res.data && res.data.results;
      },
      (err) =>
        dispatch({
          type: GET_DIRECTORIES_FAILURE,
          err,
        }),
    ),
  });

export const getDirectoryDataById = (dispatch, id, isForEditInfo = false) =>
  dispatch({
    type: isForEditInfo
      ? GET_DIRECTORY_DATA_FOR_EDIT_REQUESTED
      : GET_DIRECTORY_DATA_BY_ID_REQUESTED,
    payload: apiClient.documentLibrary.getDirectoryData(id).then(
      (res) =>
        dispatch({
          type: isForEditInfo
            ? GET_DIRECTORY_DATA_FOR_EDIT_SUCCESS
            : GET_DIRECTORY_DATA_BY_ID_SUCCESS,
          payload: res,
        }),
      (err) =>
        dispatch({
          type: isForEditInfo
            ? GET_DIRECTORY_DATA_FOR_EDIT_FAILURE
            : GET_DIRECTORY_DATA_BY_ID_FAILURE,
          err,
        }),
    ),
  });

export const getDirectoriesById = (
  dispatch,
  queryParams = {},
  id,
  isInfo = true,
) =>
  dispatch({
    type: GET_DIRECTORIES_BY_ID_REQUESTED,
    payload: apiClient.documentLibrary.getDirsAndDocs(id, queryParams).then(
      (res) => {
        isInfo && getDirectoryDataById(dispatch, id);
        return dispatch({
          type: GET_DIRECTORIES_BY_ID_SUCCESS,
          res,
        });
      },
      (err) =>
        dispatch({
          type: GET_DIRECTORIES_BY_ID_FAILURE,
          err,
        }),
    ),
  });

export const createFolder = (
  dispatch,
  data,
  id,
  isEditAction,
  parentId,
  queryParams = {},
) =>
  dispatch({
    type: isEditAction
      ? UPDATE_DIRECTORY_REQUESTED
      : CREATE_DIRECTORY_REQUESTED,
    payload: (isEditAction
      ? apiClient.documentLibrary.updateDirectory(data, id)
      : apiClient.documentLibrary.createDirectory(data, id)
    ).then(
      (res) => {
        const directoryId = isEditAction ? parentId : id;
        getTodayCount(getDirectoriesById, dispatch, queryParams, directoryId);
        getDirectoriesById(dispatch, queryParams, directoryId);
        return dispatch({
          type: isEditAction
            ? UPDATE_DIRECTORY_SUCCESS
            : CREATE_DIRECTORY_SUCCESS,
          payload: res,
        });
      },
      (err) =>
        dispatch({
          type: isEditAction
            ? UPDATE_DIRECTORY_FAILURE
            : CREATE_DIRECTORY_FAILURE,
          err,
        }),
    ),
  });

export const globalSearch = (dispatch, queryParams) =>
  dispatch({
    type: SEARCH_DIRECTORY_REQUESTED,
    payload: apiClient.documentLibrary.globalSearch(queryParams).then(
      (res) => {
        dispatch({
          type: CLEAR_DIRECTORY_DATA,
        });
        return dispatch({
          type: SEARCH_DIRECTORY_SUCCESS,
          res,
        });
      },
      (err) =>
        dispatch({
          type: SEARCH_DIRECTORY_FAILURE,
          err,
        }),
    ),
  });

export const getNumberOfChildren = (dispatch, id) =>
  dispatch({
    type: GET_NUMBER_OF_CHILDREN_REQUESTED,
    payload: apiClient.documentLibrary.getNumberOfDirectories(id).then(
      (res) =>
        dispatch({
          type: GET_NUMBER_OF_CHILDREN_SUCCESS,
          payload: res,
        }),
      (err) =>
        dispatch({
          type: GET_NUMBER_OF_CHILDREN_FAILURE,
          err,
        }),
    ),
  });

export const uploadFile = (dispatch, id, data) => {
  const defaultPaginationLimit = loadUser()?.defaultPaginationLimit || 50;
  return dispatch({
    type: UPLOAD_FILE_REQUESTED,
    payload: apiClient.documentLibrary.uploadDocument(id, data).then(
      (res) => {
        getTodayCount(getDirectoriesById, dispatch, {}, id);
        getDirectoriesById(dispatch, { limit: defaultPaginationLimit }, id);
        sendGA4Event('upload_item');
        return dispatch({
          type: UPLOAD_FILE_SUCCESS,
          payload: res,
        });
      },
      (err) =>
        dispatch({
          type: UPLOAD_FILE_FAILURE,
          err,
        }),
    ),
  });
};

export const checkDocument = (dispatch, id, filename, data) =>
  dispatch({
    type: CHECK_DOCUMENT_REQUESTED,
    payload: apiClient.documentLibrary.checkDocument(id, filename).then(
      (res) => {
        if (res.data && res.data.attachedToMessages) {
          const modalProps = {
            bodyText: i18n.t('documentLibrary.checkDocNote'),
            confirmText: i18n.t('actions.uploadAndReplace'),
            onConfirm: () => uploadFile(dispatch, id, data),
          };
          return dispatch({
            type: SET_MODAL_TYPE,
            modalType: CONFIRM,
            modalProps,
          });
        }
        if (res.data && res.data.exists) {
          const modalProps = {
            bodyText: i18n.t('documentLibrary.alreadyExistNote'),
            confirmText: i18n.t('actions.uploadAndReplace'),
            onConfirm: () => uploadFile(dispatch, id, data),
          };
          return dispatch({
            type: SET_MODAL_TYPE,
            modalType: CONFIRM,
            modalProps,
          });
        }
        uploadFile(dispatch, id, data);
        return dispatch({
          type: CHECK_DOCUMENT_SUCCESS,
          payload: res,
        });
      },
      (err) =>
        dispatch({
          type: CHECK_DOCUMENT_FAILURE,
          err,
        }),
    ),
  });

export const onDelete = (dispatch, itemId, id, typeOfItem, queryParams) =>
  dispatch({
    type:
      typeOfItem === 'directory'
        ? DELETE_DIRECTORY_REQUESTED
        : DELETE_FILE_REQUESTED,
    payload: (typeOfItem === 'directory'
      ? apiClient.documentLibrary.deleteDirectories(itemId)
      : apiClient.documentLibrary.deleteDocuments(itemId)
    ).then(
      (res) => {
        id !== null
          ? getDirectoriesById(dispatch, queryParams, id)
          : getRootDirectories(dispatch, queryParams);
        return dispatch({
          type:
            typeOfItem === 'directory'
              ? DELETE_DIRECTORY_SUCCESS
              : DELETE_FILE_SUCCESS,
          payload: res,
        });
      },
      (err) =>
        dispatch({
          type:
            typeOfItem === 'directory'
              ? DELETE_DIRECTORY_FAILURE
              : DELETE_FILE_FAILURE,
          err,
        }),
    ),
  });

export const clearDocumentLibrary = (dispatch) => {
  dispatch({
    type: CLEAR_ALL_DIRECTORY_DATA,
  });
  return dispatch({
    type: CLEAR_DIRECTORY_DATA,
  });
};

export const getDocument = (dispatch, documentId) =>
  dispatch({
    type: GET_DOCUMENT_REQUEST,
    payload: apiClient.documentLibrary.getDocument(documentId).then(
      (res) => {
        dispatch({
          type: GET_DOCUMENT_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_DOCUMENT_FAILURE,
          err,
        }),
    ),
  });
